import { styled } from '@mui/material/styles';

// Wrapper around the Carousel that targets the inner slider list and applies the bottom padding.
// (Originally a className passed to sliderClass; now applied via descendant selector.)
export const CarouselWrap = styled('div')(({ theme }) => ({
  '& .react-multi-carousel-list, & .react-multi-carousel-track': {
    paddingBottom: theme.spacing(4),
  },
}));
